import { Tabs } from 'antd-v5';
import { useHistory } from 'react-router-dom';
import type { ITab } from '@/types';
import './index.less';
import HomeIcon from './img/home.png';
import CloseIcon from './img/close.png';
import RefreshIcon from './img/refresh.png';
import EllipsisText from '../EllipsisText';

const { TabPane } = Tabs;
const HOME_PAGE = '/afs-sip/repair-info-search';

type P1 = {
  tabs: ITab[];
  tabsDict: Record<string, ITab>;
  activeTab: string | undefined;
  removeTabs: (key: string) => void;
};

const KeepAliveTabs = (props: P1) => {
  const { tabs, activeTab = '', removeTabs } = props;
  const history = useHistory();
  const [pathname] = activeTab.split('?');
  function handleTabClick(key: string) {
    if (key === activeTab) {
      return;
    }
    if (key === HOME_PAGE) {
      history.push(`${HOME_PAGE}`);
      return;
    }
    tabs.some(tab => {
      if (tab.key === key) {
        history.push(`${tab.path ?? ''}`);
        return;
      }
    });
  }

  const onRemove = (targetKey: string) => {
    removeTabs(targetKey);
  };
  return (
    <Tabs
      hideAdd
      activeKey={activeTab}
      type='editable-card'
      onChange={handleTabClick}
      id={'keep-alive-tabs-index-keep-alive-tabs'}
      popupClassName={'keep-alive-tabs-index-keep-alive-tabs'}
    >
      <TabPane tab={<img className={'icon-home'} src={HomeIcon} />} key={HOME_PAGE} />
      {tabs.map(item => {
        if (item.key === HOME_PAGE) {
          return;
        }
        return (
          <TabPane
            tab={
              <span data-translateKey={'menu.' + item.title} className={'tab-item'}>
                <img
                  className={'icon-refresh'}
                  onClick={e => {
                    e.stopPropagation();
                    const search = window.location.search;
                    const urlSearchParams = new URLSearchParams(search);
                    urlSearchParams.set('should_refresh', `${Date.now()}`);
                    history.replace(`${pathname}?${urlSearchParams.toString()}`);
                  }}
                  src={RefreshIcon}
                />
                <EllipsisText text={item.title} />
                <div
                  className={'icon-close'}
                  onClick={e => {
                    e.stopPropagation(); // 确保事件不会冒泡到父元素
                    onRemove(item.key);
                  }}
                >
                  <img src={CloseIcon} />
                </div>
              </span>
            }
            key={item.key}
          />
        );
      })}
    </Tabs>
  );
};

export default KeepAliveTabs;
